/* Live pricing for app pages.

   snippets/service-packages.liquid marks the pricing band with
   data-cb-app-pricing, the feed URL (data-src) and the app's App Store slug
   (data-slug). This script fetches the feed, finds the app with that slug and
   rebuilds the cards with the same .svc-pack markup the Liquid render uses, so
   live and server-rendered plans look identical.

   Feed shape: { apps: [ { slug, url, plans: [ { name, priceText, interval,
   features[], trial, notes[] } ] } ] }

   The feed is remote data: every value goes in through textContent, and the
   button only links to an apps.shopify.com listing. If the request fails or the
   app has no plans, the server-rendered plans stay (or the band stays hidden). */
(function () {
  var ARROW =
    '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
    '<path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';

  var requests = {};

  function load(src) {
    if (!requests[src]) {
      requests[src] = fetch(src, { credentials: 'omit' }).then(function (response) {
        if (!response.ok) throw new Error('Pricing feed ' + response.status);
        return response.json();
      });
    }
    return requests[src];
  }

  function str(value) {
    return typeof value === 'string' ? value.trim() : typeof value === 'number' ? String(value) : '';
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  }

  function storeUrl(value) {
    var url = str(value);
    try {
      var parsed = new URL(url);
      return parsed.protocol === 'https:' && parsed.hostname === 'apps.shopify.com' ? parsed.href : '';
    } catch (error) {
      return '';
    }
  }

  function card(plan, href, ctaLabel) {
    var pack = el('div', 'svc-pack');
    var name = str(plan.name);
    if (name) pack.appendChild(el('h3', 'svc-pack__name', name));

    var amount = str(plan.priceText);
    if (amount) {
      var price = el('p', 'svc-pack__price');
      price.appendChild(el('span', 'svc-pack__amount', amount));
      var interval = str(plan.interval).replace(/^\/+/, '');
      if (interval && plan.price !== 0 && !/free/i.test(amount)) {
        price.appendChild(el('span', 'svc-pack__period', '/' + interval));
      }
      pack.appendChild(price);
    }

    var notes = [str(plan.trial)];
    if (Array.isArray(plan.notes)) notes = notes.concat(plan.notes.map(str));
    notes.forEach(function (note) {
      if (note) pack.appendChild(el('p', 'svc-pack__note', note));
    });

    var features = Array.isArray(plan.features) ? plan.features.map(str).filter(Boolean) : [];
    if (features.length) {
      var list = el('ul', 'svc-pack__features');
      list.setAttribute('role', 'list');
      features.forEach(function (feature) {
        list.appendChild(el('li', '', feature));
      });
      pack.appendChild(list);
    }

    if (href && ctaLabel) {
      var cta = el('div', 'svc-pack__cta');
      var link = el('a', 'svc-btn');
      link.href = href;
      link.target = '_blank';
      link.rel = 'noopener';
      link.appendChild(el('span', '', ctaLabel));
      link.insertAdjacentHTML('beforeend', ARROW);
      cta.appendChild(link);
      pack.appendChild(cta);
    }

    return pack;
  }

  function init(band) {
    if (band.dataset.cbPricingBound) return;
    band.dataset.cbPricingBound = '1';

    var src = band.getAttribute('data-src');
    var slug = str(band.getAttribute('data-slug')).toLowerCase();
    var grid = band.querySelector('[data-cb-app-pricing-cards]');
    if (!src || !slug || !grid) return;

    load(src)
      .then(function (data) {
        var apps = data && Array.isArray(data.apps) ? data.apps : [];
        var app = null;
        for (var i = 0; i < apps.length; i++) {
          if (apps[i] && str(apps[i].slug).toLowerCase() === slug) {
            app = apps[i];
            break;
          }
        }
        var plans = app && Array.isArray(app.plans) ? app.plans.filter(Boolean) : [];
        if (!plans.length) return;

        var href = storeUrl(app.url);
        var ctaLabel = str(band.getAttribute('data-cta-label'));
        var fragment = document.createDocumentFragment();
        plans.forEach(function (plan) {
          fragment.appendChild(card(plan, href, ctaLabel));
        });

        while (grid.firstChild) grid.removeChild(grid.firstChild);
        grid.appendChild(fragment);
        band.hidden = false;
        band.setAttribute('data-cb-pricing-source', 'live');
      })
      .catch(function () {
        // Keep whatever Liquid rendered.
      });
  }

  function run() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-cb-app-pricing]'), init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
